function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.3106 91.3364C120.846 68.979 192.107 21.8337 263.257 16.6221C380.598 8.02698 404.968 91.3363 296.921 91.3364C258.425 91.3364 246.187 198 133.351 198C34.8087 198 -53.6544 116.828 39.3106 91.3364Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 175.302,
  cy: 52.6147,
  rx: 52.603,
  ry: 52.6145,
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 129.603,
  cy: 129.386,
  rx: 52.603,
  ry: 52.6145,
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 231.5,
  cy: 43.5,
  r: 18.5,
  fill: "url(#paint2_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 220.397,
  cy: 129.386,
  rx: 52.603,
  ry: 52.6145,
  fill: "url(#paint3_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 107,
  r: 12,
  fill: "url(#paint4_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 238.511,
  y1: 147.236,
  x2: 122.666,
  y2: -15.3218,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#315EFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#315EFB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 192.811,
  y1: 224.007,
  x2: 76.9664,
  y2: 61.4493,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#28BC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#28BC00",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 253.73,
  y1: 76.7701,
  x2: 213,
  y2: 19.6041,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#28BC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#28BC00",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 277.359,
  y1: 162.749,
  x2: 137.819,
  y2: 154.111,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DADAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEEEFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 93.9945,
  y1: 114.609,
  x2: 62.1619,
  y2: 112.638,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DADAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEEEFF",
  stopOpacity: 0
})));

function SvgMulticurrys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 198,
    viewBox: "0 0 366 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulticurrys);
export default __webpack_public_path__ + "static/media/multicurrys.877de9de.svg";
export { ForwardRef as ReactComponent };